export default __webpack_public_path__ + "static/media/habilitacomercio.621ca7c6.jpeg";